import { Button, Loader } from '@mantine/core';
import { ACCOUNT, HOME, ORDERS } from 'navigation/routes';
import QUERY_KEYS from 'network/config/queryKeys';
import { getMadinaOrderTracking } from 'network/services/madina';
import { useQuery } from 'react-query';
import { Link, useSearchParams } from 'react-router-dom';

const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get('order_id') ?? searchParams.get('orderId');
  const numericOrderId = Number(orderId);

  const { data: tracking, isLoading } = useQuery({
    queryKey: [QUERY_KEYS.MADINA_ORDER_TRACKING, orderId],
    queryFn: () => getMadinaOrderTracking(numericOrderId),
    enabled: Number.isFinite(numericOrderId) && numericOrderId > 0,
    refetchOnWindowFocus: false
  });

  const statusLabel = tracking?.status_label || tracking?.status;

  return (
    <div className="min-h-[60vh] flex items-center justify-center px-4">
      <div className="max-w-md w-full rounded-2xl border border-green-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-green-100 text-2xl text-green-700">
          ✓
        </div>
        <h1 className="text-2xl font-bold mb-2 text-gray-900">Payment successful</h1>
        <p className="text-gray-600 mb-4">
          Madina confirmed this payment. We&apos;re preparing your order
          {orderId ? (
            <>
              {' '}
              <strong>#{orderId}</strong>
            </>
          ) : null}
          .
        </p>
        {isLoading ? <Loader className="mx-auto mb-4" color="blue" size="sm" /> : null}
        {statusLabel ? (
          <p className="text-sm text-gray-700 mb-6">
            Order status: <strong>{statusLabel}</strong>
          </p>
        ) : (
          <div className="mb-6" />
        )}
        <div className="flex flex-col gap-3">
          <Button
            component={Link}
            to={orderId ? `${ACCOUNT}/${ORDERS}/${orderId}/track` : `${ACCOUNT}/${ORDERS}`}>
            {orderId ? 'Track order' : 'View my orders'}
          </Button>
          <Link to={HOME} className="text-blue-600 hover:underline text-sm">
            Continue shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CheckoutSuccessPage;
